<template lang="pug">
  .report
    PCheckbox(v-model="reportOptions.noValue" :label="`Omitir ${$wp('employee')} com valores zerados`")
    PCheckbox(v-model="reportOptions.resignation" :label="`Exibir ${$wp('employee')} demitidos`")
    PCheckbox(v-model="reportOptions.compensateWho" label="Desconsiderar horas que entraram para o banco de horas")
    PCheckbox(v-model="reportOptions.omitirApontamentosQuandoBHPositivo" label="Omitir faltas, atrasos e saídas antecipadas em caso de BH positivo no período")
    PCheckbox(v-model="reportOptions.incluirAbaTotalPorEmpregador" label="Incluir aba de total por empregador")
    PCheckbox(v-model="reportOptions.incluirAbaTotalPorLocalDeTrabalho" label="Incluir aba de total por local de trabalho")
    .button
      PButton(color="success" size="md" @click="generate()" :loading="loading" :disabled="!valid") gerar excel

</template>

<script>
import moment from 'moment'

export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        noValue: true,
        resignation: false,
        compensateWho: false,
        omitirApontamentosQuandoBHPositivo: false,
        incluirAbaTotalPorEmpregador: false,
        incluirAbaTotalPorLocalDeTrabalho: false
      }
    }
  },
  methods: {
    async generate () {
      this.loading = true

      let result

      const params = {
        companies: [],
        employees: [],
        groups: [],
        start_date: moment(this.reportInfo.periodData.startDate).format('DD/MM/YYYY'),
        end_date: moment(this.reportInfo.periodData.endDate).format('DD/MM/YYYY'),
        ...this.reportOptions
      }

      if (this.reportInfo.entity === 'companies') {
        params.companies = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'employees') {
        params.employees = this.reportInfo.entityContent.map(i => i.id)
      } else if (this.reportInfo.entity === 'user_group') {
        params.groups = this.reportInfo.entityContent.map(i => i.id)
      }

      try {
        result = await this.$API.R27.save(params)
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;
  .button {
    justify-self: end;

    display: grid;
    grid-auto-flow: column;
    grid-column-gap: 10px;
  }
}
</style>
